// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-submit-bar{position:sticky;bottom:0px;left:0px;z-index:3;grid-column:1 / -1;display:flex;width:100%;justify-content:flex-end;background-color:var(--p-bg-color-default);border-left:1px solid var(--p-border-color-default);box-shadow:var(--p-box-shadow-xl-y-flip);padding:var(--p-spacing-sm)}.p-submit-bar--in-modal{border-left:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
